import { CashRequestOptions, post } from '@cash-web/shared-util-fetch'
import { GetProfilesByAccountholderRequest } from '@cash-web/shared-util-protos/squareup/cash/janus/api/AccountholderProfile.pb'
import { GetProfilesByAccountholderResponse } from '@cash-web/shared-util-protos/squareup/cash/janus/api/AccountholderProfile.pb'

export const getProfilesByAccountholderInternal = (
  request: GetProfilesByAccountholderRequest,
  options?: CashRequestOptions
) =>
  post<GetProfilesByAccountholderRequest, GetProfilesByAccountholderResponse>(
    '/2.0/cash/get-profiles-by-accountholder-internal',
    request,
    { ...options, rejectOnError: true }
  )
